<template>
  <div class="card">
    <div class="card-header">
      <p class="card-title">Pagamento</p>
    </div>
    <div class="card-body">
      <FormasPagamento :formasDePagamento="formasDePagamento"  />
      <CartaoPagamento
        :apresentarDebitoAutomatico="false"
        :isLoading="isLoading"
        :isLoadingCartao="isLoadingCartao"
        :bandeiraDoCartao="bandeiraDoCartao"
        :cartoes="cartoes"
        :obterBandeiraInputProp="obterBandeiraInput"
        :obterBandeiraProp="obterBandeira"
        :desativarGerenciador="false"
        :flagsDeControle="flagsDeControle"
        :listaDeErros="listaDeErros"
        @determinarBandeiraDoCartao="determinarBandeiraDoCartao"
        @definirFormulario="definirFormulario"
        @definirCartaoPadrao="definirCartaoPadrao"
        @cadastrarCartao="cadastrarCartao"
        @selecionarCartao="selecionarCartao"
        @excluirCartao="excluirCartao"
      />
    </div>
  </div>
</template>

<script>
import Pagamento from './js/pagamento'
export default Pagamento
</script>
